export default function findTopSth (data) {
  const amount = 5
  const _data = []
  for (const [name, count] of Object.entries(data)) {
    _data.push({
      name: name,
      late: count.late,
      onTime: count.onTime,
      success: count.late + count.onTime
    })
  }
  const _ontime = _data
    .sort((a, b) => {
      return b.onTime - a.onTime
    })
    .slice(0, amount)
    .filter(i => i.onTime !== 0)
  const _late = _data
    .sort((a, b) => {
      return b.late - a.late
    })
    .slice(0, amount)
    .filter(i => i.late !== 0)
  const _success = _data
    .sort((a, b) => {
      return b.success - a.success
    })
    .slice(0, amount)
    .filter(i => i.success !== 0)
  return [_success, _ontime, _late]
}
